import AuthService from "../services/AuthService";
import {AUTH_TOKEN, REFRESH_TOKEN, REMEMBER_ME} from "../constants/AuthConstant";
import {getCookie, setJwtCookie} from "../services/CookieService";

const refreshJwtToken = async () => {
    let jwtToken = getCookie(AUTH_TOKEN) || null;
    if (!jwtToken) {
        const refreshToken = getCookie(REFRESH_TOKEN);
        const response = await AuthService.refreshToken({
            "refresh_token": refreshToken
        });

        if (response) {
            setJwtCookie(response, getCookie(REMEMBER_ME));
        }
    }
};

export default refreshJwtToken;
